import React from "react";
import { TrendingDown, Globe, Package, Hammer } from "lucide-react";
import MerkezHubShell from "@/components/MerkezHubShell";

const TABS = [
    { id: "rayic", label: "Rayiç İstihbarat", icon: TrendingDown },
    { id: "partsouq", label: "Partsouq OEM", icon: Globe },
    { id: "bilus", label: "Bilus Parça", icon: Package },
    { id: "hasar", label: "Hasar Merkezi", icon: Hammer },
];

export default function RayicParcaMerkezLayout() {
    return (
        <MerkezHubShell
            title="Rayiç & Parça Merkezi"
            subtitle="Piyasa rayiç, OEM fiyat karşılaştırma, Bilus ve hasar/ekspertiz analizi."
            badge="İstihbarat · Parça · Hasar"
            basePath="/yeni/rayic-parca-merkezi"
            tabs={TABS}
        />
    );
}
